/**
 * Carto Voyager basemap (OpenStreetMap data, served by Carto CDN).
 * Attribution: © OpenStreetMap © CARTO — matches common Leaflet + Carto setups.
 * Override at build time with LEAFLET_TILE_URL / LEAFLET_TILE_ATTRIBUTION in env.
 */
export const LEAFLET_DEFAULT_TILE_URL =
    "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png";

export const LEAFLET_DEFAULT_TILE_ATTRIBUTION =
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank" rel="noopener noreferrer">CARTO</a>';

export type LeafletTileConfig = {
    url: string;
    attribution: string;
    /** Carto uses a–d; omit when overriding URL with a host that does not use {s}. */
    subdomains?: string;
};

export function getLeafletTileConfig(): LeafletTileConfig {
    const url =
        typeof __LEAFLET_TILE_URL__ !== "undefined" && __LEAFLET_TILE_URL__
            ? __LEAFLET_TILE_URL__
            : LEAFLET_DEFAULT_TILE_URL;
    const attribution =
        typeof __LEAFLET_TILE_ATTRIBUTION__ !== "undefined" && __LEAFLET_TILE_ATTRIBUTION__
            ? __LEAFLET_TILE_ATTRIBUTION__
            : LEAFLET_DEFAULT_TILE_ATTRIBUTION;
    const usesCustomUrl = typeof __LEAFLET_TILE_URL__ !== "undefined" && !!__LEAFLET_TILE_URL__;
    return {
        url,
        attribution,
        ...(!usesCustomUrl ? { subdomains: "abcd" } : {}),
    };
}
